<div fxFill fxLayout="column">
    <h1>{{pageTitle}}</h1>

        <div fxLayout="row" fxLayoutGap="10px">
            <!-- assignment title -->
            <mat-form-field fxFlex="100">
                <span>
                    <input matInput id="createAssignmentTitle{{createAssignmentTitle}}" name="createAssignmentTitle" autocomplete="createAssignmentTitle" placeholder="Assignment Title" [(ngModel)]="assignment.title">
                </span>    
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">

            <!-- team -->
            <team-component 
                [(team)]="teamService.team"
                [canEdit]="true"
                (teamChanged)="teamUpdate($event, assignment)">
            </team-component>

            <!-- due date -->
            <mat-form-field>
                <input matInput id="createAssignmentDueDate{{createAssignmentDueDate}}" name="createAssignmentDueDate" autocomplete="createAssignmentDueDate" [matDatepicker]="picker" placeholder="Due Date" [(ngModel)]="assignment.dueDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutWrap layoutAlign="start end" fxLayoutGap="10px">
            <!-- slide count -->
            <slideCount-component  [(value)]="assignment.slideCount"></slideCount-component>

            <!-- slide word count -->
            <slideWordCount-component *ngIf="assignment.childType != 'quiz'" [(value)]="assignment.slideWordCount"></slideWordCount-component>
            
            <!-- priority -->
            <priority-component [(value)]="assignment.priority"></priority-component>

            <!-- quizType -->
            <quiz-type-component *ngIf="assignment.childType == 'quiz'" [(quizType)]="assignment.quizType" [canEdit]="true"></quiz-type-component>

            <!-- abbreviation -->
            <mat-form-field>
                <input matInput id="createAssignmentAbbr{{createAssignmentAbbr}}" name="createAssignmentAbbr" autocomplete="createAssignmentAbbr" placeholder="Ad Acronym" [(ngModel)]="assignment.abbreviation">
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutWrap layoutAlign="start" fxLayoutGap="10px" *ngIf="assignment.childType != 'quiz'">
            <!-- intro -->
            <intro-outro-component 
                fxLayout="column"
                [(count)]="assignment.introWordCount"
                [(checked)]="assignment.intro"
                title="Intro">
            </intro-outro-component>
            
            <!-- outro -->
            <intro-outro-component
                fxLayout="column"
                [(count)]="assignment.outroWordCount"
                [(checked)]="assignment.outro"
                title="Outro">
            </intro-outro-component>

            <!-- narrative -->
            <div fxLayout="column">
                <mat-checkbox class="mat-form-field-infix" name="narrative" [(ngModel)]="assignment.narrative">Narrative</mat-checkbox>
            </div>

            <!-- n2s -->
            <div fxLayout="column">
                <mat-checkbox class="mat-form-field-infix" name="n2s" [(ngModel)]="assignment.n2s">N2S</mat-checkbox>
            </div>

        </div>

        <!-- affiliates -->
        <affiliates-component
            [canEdit]="true"
            [(affiliates)]="assignment.affiliates"
            [(affiliated)]="assignment.affiliated">
        </affiliates-component>
        

        <div fxLayout="row" fxLayoutWrap fxLayoutGap="10px">
            <!-- reference -->
            <mat-form-field>
                <input matInput id="createAssignmentReference{{createAssignmentReference}}" name="createAssignmentReference" autocomplete="createAssignmentReference" placeholder="Reference" [(ngModel)]="assignment.reference">
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutWrap fxLayoutGap="10px">
            <!-- notes -->
            <notes-component #notes [(id)]="assignment.id" (commentsChange)="addComment($event)"></notes-component>
        </div>

        <div fxLayout="row">
            <!-- properties -->
            <properties-component 
                [(properties)]="assignment.sites"
                [canEdit]="true"
                [editSlug]="false"
                [showMeta]="false"
                (propertiesChange)="teamUpdate($event, assignment)"
                [assignment]="assignment">
            </properties-component>
        </div>

        <div id="create-actions">
            <div class="messages">
                <div *ngFor="let message of messages"><mat-icon class="warning">error_outline</mat-icon> {{message}}</div>
            </div>
            <button class="button" [disabled]="disabled" type="submit" (click)="submit(false)">Create</button>
            <button class="button" [disabled]="disabled" type="submit" (click)="submit('newAssignment')">Create + Start New</button>
            <button class="button" [disabled]="disabled" type="submit" (click)="submit('copyAssignment')">Create + Start New with Same Settings</button>
            <div class="error">
                <p *ngFor="let error of errors">{{error}}</p>
            </div>
        </div>
        
</div>